module.exports = __webpack_public_path__ + "img/4-2.c73a8c41.png";